import { Box, Chip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ConfirmPopover } from "../../component";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { placeholderImage } from "../../assets/img";
export const columns = (handleView, handleDelete) => [
  {
    accessorKey: "sortOrder",
    header: "S. No.",
    style: {
      width: 70,
    },
  },
  {
    accessorKey: "thumbnail",
    header: "Thumbnail",
    style: {
      width: 250,
    },
    cell: (ele) => {
      const src = ele || placeholderImage;
      return (
        <img
          src={src}
          alt="thumbnail"
          style={{ width: "180px", height: "120px", objectFit: "cover" }}
        />
      );
      // return <img src={ele} alt="thumbnail" />;
    },
  },
  {
    accessorKey: "title",
    header: "Title",
  },
  {
    accessorKey: "description",
    header: "Description",
    style: {
      width: 235,
    },
    cell: (ele) => {
      if (!ele) return "No description";

      // Function to strip HTML tags and decode HTML entities safely
      const stripHtml = (html) => {
        if (typeof html !== "string") return "";

        // First decode HTML entities
        const decodeHtmlEntities = (text) => {
          const textarea = document.createElement("textarea");
          textarea.innerHTML = text;
          return textarea.value;
        };
        let plainText = html.replace(/<[^>]*>/g, ""); // Strip HTML tags first
        plainText = decodeHtmlEntities(plainText); // Then decode HTML entities
        return plainText.replace(/\s+/g, " ").trim(); // Clean up extra whitespace
      };
      const plainText = stripHtml(ele); // Get plain text from HTML
      const maxLength = 120;

      if (plainText.length > maxLength) {
        return (
          <div style={{ lineHeight: "1.4" }}>
            {plainText.slice(0, maxLength)}...
          </div>
        );
      }
      return <div style={{ lineHeight: "1.4" }}>{plainText}</div>;
    },
  },
  {
    accessorKey: "slug",
    header: "Copy URL",
    style: {
      width: 100,
    },
    cell: (ele, row) => {
      const fullUrl = `https://beta-test.kestoneutsav.com/blogs/${row.slug}`;
      const handleCopy = () => {
        navigator.clipboard
          .writeText(fullUrl)
          .then(() => {
            console.log("Form name copied to clipboard:", fullUrl);
          })
          .catch((err) => {
            console.error("Failed to copy:", err);
          });
      };
      return (
        <IconButton onClick={handleCopy} aria-label="copy">
          <ContentCopyIcon />
        </IconButton>
      );
    },
  },
  // {
  //   accessorKey: "sortOrder",
  //   header: "S. No.",
  //   style: {
  //     width: 70,
  //   },
  // },
  // {
  //   accessorKey: "thumbnail",
  //   header: "Thumbnail",
  //   style: { width: 120 },
  //   cell: (ele, row) => {
  //     return row.thumbnail ? (
  //       <img
  //         src={row.thumbnail}
  //         alt="Thumbnail"
  //         style={{
  //           width: "80px",
  //           height: "60px",
  //           objectFit: "cover",
  //           borderRadius: "6px",
  //         }}
  //       />
  //     ) : (
  //       "No Image"
  //     );
  //   },
  // },

  // {
  //   accessorKey: "title",
  //   header: "Title",
  // },
  // {
  //   accessorKey: "description",
  //   header: "Description",
  //   style: {
  //     width: 235,
  //   },
  //   cell: (ele) => {
  //     if (!ele) return "No description";

  //     // Function to strip HTML tags and decode HTML entities safely
  //     const stripHtml = (html) => {
  //       if (typeof html !== "string") return "";

  //       // First decode HTML entities
  //       const decodeHtmlEntities = (text) => {
  //         const textarea = document.createElement("textarea");
  //         textarea.innerHTML = text;
  //         return textarea.value;
  //       };
  //       let plainText = html.replace(/<[^>]*>/g, ""); // Strip HTML tags first
  //       plainText = decodeHtmlEntities(plainText); // Then decode HTML entities
  //       return plainText.replace(/\s+/g, " ").trim(); // Clean up extra whitespace
  //     };
  //     const plainText = stripHtml(ele); // Get plain text from HTML
  //     const maxLength = 120;

  //     if (plainText.length > maxLength) {
  //       return (
  //         <div style={{ lineHeight: "1.4" }}>
  //           {plainText.slice(0, maxLength)}...
  //         </div>
  //       );
  //     }
  //     return <div style={{ lineHeight: "1.4" }}>{plainText}</div>;
  //   },
  // },

  // {
  //   accessorKey: "isActive",
  //   header: "Status",
  //   style: { width: 100 },
  //   cell: (ele, row) => {
  //     return row.isActive ? (
  //       <Box sx={{ color: "green" }}>Active</Box>
  //     ) : (
  //       <Box sx={{ color: "red" }}>Inactive</Box>
  //     );
  //   },
  // },
  {
    accessorKey: "isActive",
    header: "Status",
    cell: (ele) => {
      return ele === true ? (
        <Chip label="Enabled" variant="outlined" color="success" size="small" />
      ) : (
        <Chip label="Disabled" variant="outlined" color="error" size="small" />
      );
    },
  },
  {
    accessorKey: "action",
    header: "Action",
    style: {
      width: 150,
    },
    cell: (ele, row) => {
      return (
        <Box>
          <IconButton
            sx={{ mr: 0.5 }}
            aria-label="edit"
            color="secondary"
            onClick={() => handleView(row, "/app/blog/add")}
          >
            <EditIcon />
          </IconButton>
          <ConfirmPopover
            title="Sure to delete?"
            onConfirm={() => handleDelete(row._id)}
          >
            <IconButton aria-label="delete" color="error">
              <DeleteOutlineIcon />
            </IconButton>
          </ConfirmPopover>
        </Box>
      );
    },
  },
];
